<template>
  <router-view></router-view>
  <GlobalModal />
  <ToastStack />
</template>

<script>
import GlobalModal from '@/components/modals/GlobalModal.vue'
import ToastStack from '@/components/toasts/ToastStack.vue'

export default {
  components: {
    GlobalModal,
    ToastStack,
  },
}
</script>
